/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { DisplayValuePair } from "./display-value-pair";
import { TaskClass } from "../enums/task-class";
import { WorkflowContextDto } from "./workflow-context-dto";

export class CmpTaskBaseDto {
    taskVariablesId: string = undefined;
    variables: any;
    number: string = undefined;
    shortDescription: string = undefined;
    description: string = undefined;
    parent: DisplayValuePair<string>;
    assignedTo: DisplayValuePair<string>;
    assignmentGroup: DisplayValuePair<string>;
    state: DisplayValuePair<string>;
    type: DisplayValuePair<string>;
    dueDate: Date = undefined;
    openedOn: Date = undefined;
    openedBy: DisplayValuePair<string>;
    closedOn: Date = undefined;
    closedBy: DisplayValuePair<string>;
    active: boolean = undefined;
    additionalComments: string = undefined;
    additionalWorkNotes: string = undefined;
    taskClass: TaskClass;
    taskId: string = undefined;
    taskKey: any;
    workflowContext: WorkflowContextDto;
}
